import { cacheIsValid, deleteContent, refreshCacheKey, safeGetItem, safeSetItem } from '@shared/cache/cache.browser';
import { log } from '@shared/log.browser.ts';

const CONTENT_KEY = 'reptile_dundee_cacheContent';

/**
 *
 *
 *
 */
export function tileListCacheKey(namespace?: string): string {
    return namespace ? `${CONTENT_KEY}:${namespace}` : CONTENT_KEY;
}

export async function saveToCache<T>(data: T, namespace?: string) {
    await safeSetItem(tileListCacheKey(namespace), JSON.stringify($state.snapshot(data)));
}

export async function maybeRestoreFromCache<T>(data: T, namespace?: string) {
    let result = data;
    const contentKey = tileListCacheKey(namespace);

    if (await cacheIsValid()) {
        const cachedTileList = await safeGetItem(contentKey);
        if (cachedTileList) {
            try {
                const parsed: T = JSON.parse(cachedTileList);
                result = parsed;
            } catch (error) {
                log.error('Failed to parse cached tileList:', error);
            }
        }
    }

    await refreshCacheKey();
    await deleteContent(contentKey);

    return result;
}
